import type { FlavorKeys } from '@feathr/blackbox';
import { Flavors } from '@feathr/blackbox';

// TODO: Remove this once the flavors are added to breadcrumbs.ts.
const donationFlavorsMap = {
  donation: 'Made a donation',
  donation_form_submission: 'Submitted a donation form',
  donation_form_view: 'Viewed a donation form',
};

export function getDescription(flavor: FlavorKeys): string {
  const map = { ...Flavors, ...donationFlavorsMap };
  return map[flavor] || flavor;
}
